<!--  -->
<template>
	<div class="container">
		<div class="flex flex-container">
			<!-- 价格方案 -->
			<div class="flex-left">
				<div class="search-container flex flex-between">
					<div class="title">价格方案</div>
					<div v-if="isEdit">
						<img class="icon-img ml7" src="@/assets/images/delete.png" @click="handleDeletePrice" title="删除" alt="">
						<img class="icon-img ml7" src="@/assets/images/add.png" @click="handleEdit" title="新增" alt="">
					</div>
				</div>
				<div class="mt10">
					<el-table
						:data="priceData"
						:height="height"
						:row-class-name="rowClassName"
						:cell-style="cellStyle"
						:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333'}"
						@cell-click="handleCellClick"
						border style="width:100%">
						<el-table-column width="60" label="选择" align="center">
							<template slot-scope="scope">
								<el-radio v-model="selecteId" :label="scope.row.priceId"></el-radio>
							</template>
						</el-table-column>
						<el-table-column prop="priceName" :show-overflow-tooltip="true" label="名称" sortable>
						</el-table-column>
						<!-- <el-table-column prop="priorityLevel" width="100" :show-overflow-tooltip="true" label="优先级" sortable>
						</el-table-column>
						<el-table-column prop="startDate" width="120" :show-overflow-tooltip="true" label="生效日期" sortable>
						</el-table-column>
						<el-table-column prop="endDate" width="120" :show-overflow-tooltip="true" label="终止日期" sortable>
						</el-table-column> -->
						<el-table-column prop="remark" :show-overflow-tooltip="true" label="备注">
						</el-table-column>
					</el-table>
				</div>
			</div>
			<!-- 价格明细 -->
			<div class="flex-right ml20">
				<div class="search-container  flex flex-between">
					<div class="title">价格明细<span class="des-text ml10">{{name ? '('+name+')' : ''}}</span></div>
					<div v-if="isEdit">
						<img class="icon-img ml7" src="@/assets/images/delete.png" @click="handleDeletePriceSku" title="删除" alt="">
						<img class="icon-img ml7" src="@/assets/images/add.png" @click="handleDescEdit" title="新增" alt="">
					</div>
				</div>
				<div class="mt10">
					<el-table
						ref="multipleTable"
						:height="height"
						:data="priceSkuData"
						:row-class-name="rowClassName"
						:cell-style="cellStyle"
						:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333'}"
						@cell-click="handleSkuCellClick"
						@selection-change="handleSelectionChange"
						border style="width:100%">
						<el-table-column type="selection" width="50" align="center">
						</el-table-column>
						<el-table-column prop="skuName" :show-overflow-tooltip="true" label="SKU名称" sortable>
						</el-table-column>
						<el-table-column prop="cashPrice" :show-overflow-tooltip="true" label="售价(元)" >
						</el-table-column>
						<el-table-column prop="cashPacketPrice" :show-overflow-tooltip="true" label="整包售价(元)" >
						</el-table-column>
						<el-table-column prop="remark" :show-overflow-tooltip="true" label="备注">
						</el-table-column>
					</el-table>
				</div>
			</div>
			<!--  -->
		</div>
		<priceEdit ref="priceEdit" @getPriceList="getPriceList"></priceEdit>
		<priceDesc ref="priceDesc" @getPriceSkuList="getPriceSkuList"></priceDesc>
	</div>
</template>

<script>
	import priceEdit from './components/price-edit.vue'
	import priceDesc from './components/price-desc.vue'
	import { hasPermission } from '@/utils/permission'
	export default {
		name:'priceManage',
		components: {
			priceEdit,
			priceDesc
		},
		data() {
			return {
				height: 500,
				name: '',
				selecteId: '',
				checkboxList: [],
				priceData: [],
				priceSkuData: [],
				isEdit:false
			}
		},
		created() {
			this.height = window.innerHeight - 170;
			this.getPriceList();
			if (this.$route.meta.perm) {
				this.isEdit = hasPermission(this.$route.meta.perm);
				// console.log(this.isEdit)
			}
		},
		methods: {
			rowClassName({row,rowIndex}) {
				let index = rowIndex + 1;
				if (index % 2 == 1) {
					return 'warning-row'
				}
			},
			cellStyle({row, column, rowIndex, columnIndex}) {
				if(columnIndex == 1) {
					return 'cursor: pointer;'
				}
			},
			// 获取价格方案管理
			getPriceList() {
				let that = this;
				that.$request.post(
					"getPriceList",
					true, {
						priceType: 1
					}
				)
				.then((res) => {
					if (res) {
						that.priceData = res.data;
					}
				})
			},
			// 新增/编辑
			handleEdit() {
				this.$refs.priceEdit.init(1,this.priceData.length>0?this.priceData[0].priorityLevel:'');
			},
			// 点击价格方案
			handleCellClick(row, column, cell, event) {
				if(column.label == '名称') {
					this.$refs.priceEdit.init(2,row);
				}else {
					this.selecteId = row.priceId;
					this.name = row.priceName;
					this.getPriceSkuList();
				}
			},
			// 删除价格方案
			handleDeletePrice() {
				if(this.selecteId == ''){
					return
				}
				this.$confirm('该价格方案删除后对应客商设置的该价格方案将会被清除，确认要删除吗？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					let that = this;
					that.$request.post(
						"deletePriceMain",
						true, {
							priceId: that.selecteId
						}
					)
					.then((res) => {
						if (res) {
							that.selecteId = '';
							that.name = '';
							that.getPriceList();
							that.$message.success('删除成功');
						}
					})
				}).catch(() => {

				});
			},
			// 获取价格方案明细
			getPriceSkuList() {
				let that = this;
				that.$request.post(
					"getPriceSkuList",
					true, {
						priceId: that.selecteId,
						priceType: 1
					}
				)
				.then((res) => {
					if (res) {
						that.priceSkuData = res.data;
					}
				})
			},
			// 价格明细编辑
			handleDescEdit(){
				if(this.selecteId == '') {
					this.$message.error('请选择价格方案');
					return
				}
				this.$refs.priceDesc.init(this.selecteId);
			},
			// 点击cell
			handleSkuCellClick(row, column, cell, event) {
				if(column.label == 'SKU名称') {
					this.$refs.priceDesc.init(this.selecteId,row);
				}else {
					this.$refs.multipleTable.toggleRowSelection(row);
				}
			},
			handleSelectionChange(val) {
				this.checkboxList = val;
			},
			// 删除价格方案
			handleDeletePriceSku() {
				if(this.checkboxList.length == 0){
					return
				}
				let priceSkuIds = [];
				this.checkboxList.forEach(item => {
					priceSkuIds.push(item.priceSkuId);
				})
				this.$confirm('确认要删除选中的价格明细吗？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					let that = this;
					that.$request.post(
						"deletePriceSku",
						true, {
							priceSkuIds: priceSkuIds
						}
					)
					.then((res) => {
						if (res) {
							that.checkboxList = [];
							that.getPriceSkuList();
							that.$message.success('删除成功');
						}
					})
				}).catch(() => {

				});
			},
		},
		beforeDestroy() {

		}
	}

</script>

<style lang='scss' scoped>
	.container {
		// width: 99%;
		box-sizing: border-box;
			margin: 12px 26px 15px 10px;
		// padding-bottom: 20px;

		.el-table {

			// 深度选择器，去除默认的padding
			/deep/ th {
				padding: 0px;
			}

			/deep/ td {
				padding: 5px;
			}

			/deep/ .warning-row {
				background: #F1F1F5;
			}
			/deep/ th .el-table__cell{
				padding: 0 !important;
			}
		}
	}

	.search-container {
		 background: #F9FAFD;
         padding: 5px;
	}

	.flex-container {
		width: 100%;
		align-items: flex-start;
		box-sizing: border-box;
	}

	.flex-left {
		width: 55%;
		background: #fff;
		box-sizing: border-box;
		padding:10px;
	}

	.flex-right {
		width: 43%;
		background: #fff;
		box-sizing: border-box;
		padding:10px;
	}
	.table-container{
		width: 100%;
		box-sizing: border-box;
	}
	.title{
		line-height: 32px;
	}
	.el-table__body-wrapper {
		overflow-y: scroll !important;
	}
</style>
<style scoped>
.cursor{
	cursor: pointer;
}
>>> .el-radio {
  margin-left: 6px;
}
>>> .el-radio .el-radio__label {
  display: none;
}
</style>
